
import { BModal } from 'bootstrap-vue'
import { Component, Prop, Ref, Vue } from 'nuxt-property-decorator'
import { PlatformSettingsWeb } from '~/api'

@Component({
  components: {
    BModal,
  },
})
export default class StylizedModal extends Vue {
  @Prop({ required: true }) readonly modalId!: string
  @Prop({ default: 'md' }) readonly size!: string
  @Prop({ default: false }) readonly centered!: boolean
  @Prop({ default: false }) readonly hideFooter!: boolean
  @Prop({ default: '' }) readonly title!: string
  @Prop({ default: false }) readonly scrollable!: boolean
  @Prop({ default: '' }) readonly contentClass!: string
  @Prop() platformSettings!: PlatformSettingsWeb

  @Ref('modal') public modal!: BModal

  show() {
    this.modal.show()
  }

  hide() {
    this.modal.hide()
  }
}
